import React, { useState, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import notepadIcon from '../../../../../../assets/svg/notepad.svg';
import { store as mainStore } from '../../../../../../store';
import { store } from './Freight';
import { useParams } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
  noteField: {
    background: `url(${notepadIcon}) no-repeat`,
    backgroundSize: '150px',
    backgroundPosition: '10px 10px',
  },
}));

function AddNote() {
  const { id } = useParams();
  const classes = useStyles();
  const [note, setNote] = useState('');
  const [error, setError] = useState(false);
  const { state, dispatch } = useContext(store);
  const { addNote } = state;
  const { showMessage, showError } = useContext(mainStore);
  const [loading, setLoading] = useState(false);

  const handleChangeTF = (e) => {
    const { value } = e.target;
    setNote(value);
  };
  const handleAddNote = async () => {
    try {
      setLoading(true);
      setError(false);
      if (note) {
        const response = await addNote(id, note);
        if (response.ok) {
          showMessage(response.messages);
          dispatch({ type: 'NOTES', payload: response.notes });
          setNote('');
        } else {
          showError(response);
        }
      } else {
        setError('متن یادداشت بایستی وارد شود.');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className={classes.root}>
      <div>
        <TextField
          fullWidth
          value={note}
          onChange={handleChangeTF}
          label="یادداشتی برای این کاربر اضافه کنید"
          multiline
          rows={8}
          size="small"
          variant="outlined"
          className={classes.noteField}
          error={error ? true : false}
          helperText={error ? error : ''}
        />
      </div>

      <Button
        onClick={handleAddNote}
        variant="text"
        fullWidth
        color="secondary"
        disabled={loading}
        endIcon={loading ? <CircularProgress size={'10px'} /> : <></>}
      >
        افزودن یادداشت
      </Button>
      <Divider />
    </div>
  );
}

export default React.memo(AddNote);
